import axios, { AxiosResponse } from "axios";
import { GoogleUserPayload } from "../models/payload/GoogleUserPayload";
import client from "../client";

export function addGoogleUser(payload: GoogleUserPayload): Promise<AxiosResponse<any>> {
    return client.post<any>(`/Users/Google`, payload)
  }
  